import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getIdTokenClaims } from "../auth";

function parseGroups(claims) {
  const raw = claims?.["cognito:groups"];
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [raw];
    } catch {
      return [raw];
    }
  }
  return [];
}

function isPlatformAdminClaims(claims) {
  if (parseGroups(claims).includes("PlatformAdmin")) return true;
  const email = (claims?.email || "").toLowerCase();
  const allowlist = (process.env.REACT_APP_PLATFORM_ADMIN_EMAILS || "victor@tagnize.com,admin@tagnize.com")
    .split(",")
    .map((e) => e.trim().toLowerCase())
    .filter(Boolean);
  return allowlist.includes(email);
}

export default function RequirePlatformAdmin({ children }) {
  const [state, setState] = useState({ loading: true, allowed: false });

  useEffect(() => {
    let cancelled = false;
    getIdTokenClaims()
      .then((claims) => {
        if (!cancelled) {
          setState({ loading: false, allowed: isPlatformAdminClaims(claims) });
        }
      })
      .catch(() => {
        if (!cancelled) setState({ loading: false, allowed: false });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (state.loading) {
    return <div className="ops-loading">Verificando acceso ops…</div>;
  }
  if (!state.allowed) {
    return <Navigate to="/login" replace state={{ message: "Acceso restringido a PlatformAdmin." }} />;
  }
  return children;
}
